import theme, { rem } from '@gameday/react-components/utils/theme'
import styled from 'styled-components'

import gameDayLogoSvg from '../../../../assets/images/gameday_white.png'

const StyledFooter = styled.footer`
  width: 100%;
  display: flex;
  flex-direction: column;
  flex-basis: ${rem(70)};
  max-height: ${rem(130)};
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  margin-top: ${rem(10)};
  margin-bottom: ${rem(10)};
`

const StyledCopyrightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-grow: 1;
`

const StyledGamedayLogo = styled.img`
  height: ${rem(35)};
  margin-bottom: ${rem(5)};
  margin-right: ${rem(3)};
`

const StyledCopyrightText = styled.p`
  color: ${theme.colors.midGrey};
  text-align: center;
  font-size: ${rem(10)};
  font-weight: 400;
  line-height: 1;
`

const SmallLogoFooter = () => (
  <StyledFooter>
    <StyledCopyrightContainer>
      <StyledGamedayLogo src={gameDayLogoSvg} />
      <StyledCopyrightText>&copy; Copyright GameDay. All rights reserved.</StyledCopyrightText>
    </StyledCopyrightContainer>
  </StyledFooter>
)

export default SmallLogoFooter
